module.exports = __webpack_public_path__ + "media/images/app/how-it-works/hero-hiw-3add283a9ac252e74ede70f15240d3e9.webp";